import { useMutation } from "@apollo/client";
import { useEffect } from "react";
import type {
  ValidateInviteTokenPayload,
  ValidateInviteTokenInput,
} from "@casey/db-types";
import { VALIDATE_INVITE_TOKEN_QUERY } from "../gql/index";

export function useValidateInviteToken(token: string | null) {
  const [validateToken, { data, loading, error }] = useMutation<
    { validateInviteToken: ValidateInviteTokenPayload },
    ValidateInviteTokenInput
  >(VALIDATE_INVITE_TOKEN_QUERY, {
    errorPolicy: "all",
  });

  // Auto-trigger the mutation when token changes
  useEffect(() => {
    if (token) {
      validateToken({
        variables: { pToken: token },
      });
    }
  }, [token, validateToken]);

  return {
    data,
    loading,
    error,
    refetch: () => {
      if (token) {
        return validateToken({
          variables: { pToken: token },
        });
      }
      return Promise.resolve();
    },
  };
}
